const routers = [
  {
    // 权限角色
    path: '/role/list',
    name: 'role',
    component: () => import('@/views/modules/authority/role/List.vue')
  },
  {
    // 用户
    path: '/user/list',
    name: 'user',
    component: () => import('@/views/modules/authority/user/List.vue')
  },
  {
    // 菜单
    path: '/menu/list',
    name: 'menu',
    component: () => import('@/views/modules/authority/menu/List.vue')
  }
]
export default routers
